import React, { Component } from 'react';
import { observer, Provider, inject } from 'mobx-react';
import { ResultsStore } from './results.store';
import { autorun } from 'mobx';
import { ResultsComponent } from './results.component';
import EmailReportForm from './emailreport.form';
import EmailLinkForm from '../_shared/emaillink/emaillink.form';

@inject('appStore', 'routerStore')
@observer
export class ResultsProvider extends Component {
    store;
    disabledResultAutorun = false;
    emailReportForm;

    constructor(props) {
        super(props);
        const { appStore, match } = props;

        appStore.setURLProps(match);
        appStore.clearError();

        this.store = new ResultsStore({
            appStore
        });

        this.emailReportForm = new EmailReportForm({
            store: this.store,
            appStore,
            url: appStore.Link,
            helpURL: appStore.helpURL
        });

        this.emailLinkForm = new EmailLinkForm({
            store: props.appStore,
            appStore: props.appStore
        });

        this.disposeStore = autorun(() => {
            if (
                !appStore.loading &&
                appStore.submissionID &&
                !this.disabledResultAutorun
            ) {
                this.store.initializeResults();
                this.disabledResultAutorun = true;
            }
        });
    }

    componentWillUnmount() {
        this.disposeStore();
    }

    render() {
        return (
            <Provider
                emailReportForm={this.emailReportForm}
                emailLinkForm={this.emailLinkForm}
                store={this.store}
            >
                <ResultsComponent key='resultspage' />
            </Provider>
        );
    }
}
